import _ from "lodash";
import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import { Desktop, TabletMobile } from "../../hocs/Responsive";
import { Sidebar } from "../sidebar/Sidebar";
import { WizardSidebarMenu } from "../sidebar/WizardSidebarMenu";
import { ProfilePicker } from "../profilePicker/ProfilePicker";
import { useIntlTranslate } from "../../hooks";

export const WizardSidebarNavigation = ({
  className,
  menuClassName,
  sidebarMenuHeader,
  tabs,
  activeTab,
  activeTabClass,
  onTabKeyPress,
  onTabClick,
  ...rest
}) => {
  const translate = useIntlTranslate();

  return (
    <Fragment>
      <TabletMobile>
        <h1
          className="profiles__title"
          aria-label={translate("aria_wizard_sidebar_header_title")}
        >
          <FormattedMessage id={"wizard_sidebar_header_title"} />
        </h1>
        <ProfilePicker
          {...rest}
          activeTab={activeTab}
          activeTabClass={activeTabClass}
          tabs={tabs}
          onTabClick={onTabClick}
        />
      </TabletMobile>
      <Desktop>
        <Sidebar
          tabs={tabs}
          activeTab={activeTab || _.head(tabs).id}
          sidebarMenu={
            <WizardSidebarMenu
              menuClassName={menuClassName}
              sidebarMenuHeader={sidebarMenuHeader}
              tabs={tabs}
              activeTab={activeTab || _.head(tabs).id}
              onTabKeyPress={onTabKeyPress}
              onTabClick={onTabClick}
            />
          }
        />
      </Desktop>
    </Fragment>
  );
};

WizardSidebarNavigation.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      header: PropTypes.node.isRequired,
      content: PropTypes.node,
    })
  ).isRequired,
  onTabKeyPress: PropTypes.func.isRequired,
  onTabClick: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
  activeTabClass: PropTypes.string,
  menuClassName: PropTypes.string,
  sidebarMenuHeader: PropTypes.node,
};
